import React from 'react';
import { Input, Label } from 'reactstrap';
import { Segment, Grid, Form, Button, Checkbox } from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';
import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-widgets/dist/css/react-widgets.css';
import 'react-datepicker/dist/react-datepicker.css';


momentLocalizer(moment);
// TODO: move select to separate component
// props: filtersSelectedValues []
//        filtersAvailableValuesList {[],[],[]}
//         onFilterChange (fn)

export default class FilterForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { graduated } = this.props.filtersSelectedValues;
        if (graduated !== nextProps.filtersSelectedValues.graduated) {
            if (nextProps.filtersSelectedValues.graduated) {
                this.props.resetOrClearFilterFormDates('reset');
            } else {
                this.props.resetOrClearFilterFormDates('clear');
            }
        }
    }

    handleInputChange(event, { name, value }) {
        this.props.onFilterChange(name, value);
    }

    handleChange(event) {
        // checkboxes need to have the default event function executed or else it wont visually update

        // if (event.target.type !== 'checkbox') event.preventDefault();

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.props.onFilterChange(name, value);

        // TODO: if graduated is selected, set dates
    }
    handleDateChange(name, date) {
        if (name === 'endDate') {
            if (this.props.filtersSelectedValues.startDate && date < this.props.filtersSelectedValues.startDate) {
                this.props.onFilterChange(name, null);
                toast('Datum kraja mora biti poslije datuma početka!');
            } else this.props.onFilterChange(name, date);
        }

        if (name === 'startDate') {
            if (this.props.filtersSelectedValues.endDate && date > this.props.filtersSelectedValues.endDate) {
                this.props.onFilterChange(name, null);
                toast('Datum početka mora biti prije datuma kraja!');
            } else this.props.onFilterChange(name, date);
        }
    }
    render() {
        const { organizationalUnits, studyCycles } = this.props.filtersAvailableValuesList;
        const {
            graduated,
            locked,
            organizationalUnit,
            studyCycle,
            startDate,
            endDate,
            firstName,
            lastName,
            documentNumber,
        } = this.props.filtersSelectedValues;
        return (
            <div>
                <Form onSubmit={(e) => { e.preventDefault(); }}>
                    <Grid columns={3} centered className="stackable">

                        <Grid.Row stretched>
                            <Grid.Column>
                                <Segment.Group raised style={{ backgroundColor: 'white' }}>
                                    <Segment>
                                        <h3>Fakultet</h3>
                                    </Segment>
                                    <Segment>


                                        <Form onSubmit={(e) => { e.preventDefault(); }} noValidate>
                                            <Form.Field required error={this.props.organizationalUnitErr}>
                                                <label>Fakultet</label>
                                                <Form.Select
                                                    placeholder="Odaberite fakultet"
                                                    value={organizationalUnit}
                                                    onChange={this.handleInputChange}
                                                    name="organizationalUnit"
                                                    options={organizationalUnits}
                                                    search
                                                    fluid
                                                />

                                            </Form.Field>
                                        </Form>
                                        <br />
                                        <Form noValidate>
                                            <Form.Field required error={this.props.studyCycleErr}>
                                                <label>Ciklus studija</label>
                                                <Form.Select
                                                    placeholder="Odaberite ciklus studija"
                                                    value={studyCycle}
                                                    onChange={this.handleInputChange}
                                                    name="studyCycle"
                                                    options={studyCycles}
                                                    search
                                                    fluid
                                                />
                                            </Form.Field>
                                        </Form>
                                        <br />
                                        <br />

                                        <Checkbox
                                            type="checkbox"
                                            name="graduated"
                                            id="graduated"
                                            onChange={this.handleChange}
                                            checked={graduated}
                                            label="Diplomirani studenti"
                                        />
                                        <br />

                                        <Checkbox
                                            type="checkbox"
                                            name="locked"
                                            id="locked"
                                            onChange={this.handleChange}
                                            checked={locked}
                                            label="Zaključani studenti"
                                        />


                                    </Segment>
                                </Segment.Group>
                            </Grid.Column>
                            <Grid.Column>
                                <Segment.Group raised style={{ backgroundColor: 'white' }}>
                                    <Segment>
                                        <h3>Datumi</h3>
                                    </Segment>
                                    <Segment>
                                        <Form.Field>
                                            <label >Datum početka</label>
                                            <DateTimePicker
                                                format="D .M. YYYY."
                                                defaultValue={null}
                                                time={false}
                                                onChange={this.handleDateChange.bind(null, 'startDate')}
                                                value={startDate}
                                            />
                                        </Form.Field>


                                        <Form.Field>

                                            <label>Datum kraja</label>
                                            <DateTimePicker
                                                format="D. M. YYYY."
                                                defaultValue={null}
                                                time={false}
                                                onChange={this.handleDateChange.bind(null, 'endDate')}
                                                value={endDate}
                                            />
                                        </Form.Field>


                                    </Segment>
                                </Segment.Group>
                            </Grid.Column>

                            <Grid.Column>
                                <Segment.Group raised style={{ backgroundColor: 'white' }}>
                                    <Segment>
                                        <h3>Lični podaci</h3>
                                    </Segment>
                                    <Segment>

                                        <Form.Field>
                                            <label>Pretraga po imenu</label>
                                            <input
                                                type="text"
                                                name="firstName"
                                                id="firstName"
                                                value={firstName}
                                                onChange={this.handleChange}
                                                placeholder="Unesite ime"
                                            />
                                        </Form.Field>

                                        <Form.Field>
                                            <label>Pretraga po prezimenu</label>
                                            <Input
                                                type="text"
                                                name="lastName"
                                                id="lastName"
                                                value={lastName}
                                                onChange={this.handleChange}
                                                placeholder="Unesite prezime"
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Label for="documentNumber">Pretraga po broju diplome</Label>
                                            <Input
                                                type="text"
                                                name="documentNumber"
                                                id="documentNumber"
                                                value={documentNumber}
                                                onChange={this.handleChange}
                                                placeholder="Unesite broj diplome"
                                            />
                                        </Form.Field>

                                    </Segment>
                                </Segment.Group>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Form>
                <ToastContainer hideProgressBar />
                <br />
                <Button color="blue" floated="right" onClick={() => this.props.changeWizardStep('next')}>Filtriraj</Button>

                <Button color="blue" basic="true" floated="left" onClick={this.props.clearAllFilters}>Očisti filtere</Button>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/DegreeDocumentPrint/FilterForm.js